import { render, staticRenderFns } from "./formSelectReasons.vue?vue&type=template&id=5a17e88c&scoped=true&"
import script from "./formSelectReasons.vue?vue&type=script&lang=js&"
export * from "./formSelectReasons.vue?vue&type=script&lang=js&"
import style0 from "./formSelectReasons.vue?vue&type=style&index=0&id=5a17e88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a17e88c",
  null
  
)

export default component.exports